
import React from 'react';


type InfoPanelProps = {
    stats?: {
        today: number;
        total: number;
    }
};

export function InfoPanel({ stats }: InfoPanelProps) {
    return (
        <div className="infoPanel"> 
             {stats && <><strong>Today:</strong> {stats?.today} <strong>Total:</strong> {stats?.total} </>}
        </div>)
}
